import { features } from "@/mocks/movies";

export default function FeaturesSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
            为什么选择青柠影院
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            用心打造极致观影体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}